import React from 'react';
import { Link } from 'react-router-dom';
import { ProfileInterface } from 'types/ProfileInterface';
import CaretRightIcon from 'assets/icons/caretRight.svg?react';
import logo from 'assets/squareLogo.svg';
import styles from './Sidebar.module.css';
import LogOutIcon from 'components/Icons/LogOutIcon';

type SidebarHeaderProps = {
    toggleExpanded: (e: React.MouseEvent<HTMLButtonElement>) => void;
    profile: ProfileInterface;
    handleLogout: () => void;
};

function SidebarHeader({ toggleExpanded, profile, handleLogout }: SidebarHeaderProps) {
    return (
        <div className={styles.header}>
            <Link to="/" className={styles.logoLink} title="Back to dashboard">
                <img src={logo} alt="Logo" height="inherit" className={styles.logo} />
            </Link>
            <div className={styles.userInfo}>
                <h4>{[profile.first_name, profile.last_name].filter(Boolean).join(' ')}</h4>
                <p>{profile.email}</p>
            </div>

            <button className={styles.logoutButton} onClick={handleLogout} title="logout">
                <LogOutIcon />
            </button>

            <button className={styles.toggleButton} onClick={toggleExpanded}>
                <CaretRightIcon />
            </button>
        </div>
    );
}

export default SidebarHeader;
